export enum ClaimTypeEnum {
    Photo = "Photo",
    PhoneNumber = "PhoneNumber",
    Email = "Email",
    TerminalNumber = "TerminalNumber",
    Birthdate = "Birthdate",
    Address = "Address",
    Zipcode = "Zipcode",
    Gender = "Gender",
    CountryId = "CountryId",
    CityId = "CityId",
    StateId = "StateId",

    CompanyId = "CompanyId",
    IsTestAccount = "IsTestAccount",
    MarketerCode = "MarketerCode",
    ReferenceCode = "ReferenceCode",
    WhoReference = "WhoReference",
    IsAggrementAccepted = "IsAggrementAccepted",
    IsSmsActive = "IsSmsActive",
    IsEmailActive = "IsEmailActive",
    IsSafeExam = "IsSafeExam",
    ExamFinisher = "ExamFinisher",
    Edupoint = "Edupoint",

    ParentId = "ParentId",
    ConsultantId = "ConsultantId",
    PresentLevelId = "PresentLevelId",
    StartupLevelId = "StartupLevelId",
}